import {AccountSettingsWrapper, PolicyMoodWrapper} from "./accountSettings.styles";
import AccountInfo from "../components/AccountInfo/AccountInfo";
import Mood from "../components/AccountInfo/Mood";
import LogOut from "../components/LogOut/LogOut";
import ProfilePolicy from "../components/ProfilePolicy/ProfilePolicy";
import SwitchAccount from "../components/SwtichAccount/SwitchAccount";


const AccountSettings = () => {

        return   <AccountSettingsWrapper>
                <AccountInfo />
                        <PolicyMoodWrapper>
                                <Mood />
                                <ProfilePolicy />
                                <SwitchAccount />
                                <LogOut />
                        </PolicyMoodWrapper>


        </AccountSettingsWrapper>

}
export default AccountSettings;